import { Code, PropertyType } from '../models/property-type';

export const getPropertyTypeFromCode = (code: string): PropertyType => {
  switch (code) {
    case 'APP':
      return {
        code: 'APP',
        label: 'Appartement',
      };
    case 'MAI':
      return {
        code: 'MAI',
        label: 'Maison',
      };
    case 'LAC':
      return {
        code: 'LAC',
        label: "Local d'activité",
      };
    case 'TER':
      return {
        code: 'TER',
        label: 'Terrain',
      };
    case 'IMM':
      return {
        code: 'IMM',
        label: 'Immeuble',
      };
    case 'GAR':
      return {
        code: 'GAR',
        label: 'Garage',
      };
    case 'AGR':
      return {
        code: 'AGR',
        label: 'Bien agricole',
      };
    case 'VIG':
      return {
        code: 'VIG',
        label: 'Bien viticole',
      }
    case 'ACMAI':
      return {
        code: 'ACMAI',
        label: 'Maison',
      }
    case 'ACMAP':
      return {
        code: 'ACMAP',
        label: 'Maison / Appartement',
      }
    case 'ACAPP':
      return {
        code: 'ACAPP',
        label: 'Appartement',
      }
    default:
      return {
        code : code as Code,
        label: 'Bien'
      };
  }
};
